// src/pages/NewApp.js
import React from "react";
import Map from "../Map";
import './NewApp.css';

export default function NewApp() {
  return (
    <div style={{ paddingTop: "63px", height: "100vh", boxSizing: "border-box", overflow: "hidden" }}>
      <Map />
    </div>
  );
}
